import { ReactNode } from 'react';
import cls from 'classnames';

import Heading from '@/common/components/Heading/Heading';
import Checkbox from '@/common/components/inputs/Checkbox/Checkbox';

import styles from './GlobalAccessRadio.module.css';

export interface GlobalAccessRadioProps {
  checked: boolean;
  description?: ReactNode;
  disabled?: boolean;
  icon: ReactNode;
  isAmbient?: boolean;
  onChange: () => void;
  title: ReactNode;
  descriptionClassName?: string;
  'aria-label'?: string;
}

function GlobalAccessRadio(props: GlobalAccessRadioProps) {
  const {
    checked,
    description,
    disabled = false,
    icon,
    isAmbient = false,
    onChange,
    title,
    descriptionClassName,
    'aria-label': ariaLabel,
  } = props;

  return (
    <Checkbox
      aria-label={ariaLabel}
      ambient={isAmbient}
      checked={checked}
      className={cls(styles.checkbox, {
        [styles.checkboxDisabled]: !isAmbient && !checked && disabled,
      })}
      disabled={disabled}
      label={(
        <div>
          <div className={styles.option}>
            {icon}

            <Heading appearance="h6" className={styles.optionTitle}>
              {title}
            </Heading>
          </div>

          <div className={cls(styles.optionDescription, descriptionClassName)}>{description}</div>
        </div>
      )}
      onChange={onChange}
      type="radio"
    />
  );
}

export default GlobalAccessRadio;
